import { React, useMemo } from 'react';
import OutputTable from './outputTable'
import { post } from 'jquery';

function ResultsPanel({data, dataType}) {

    const columns = useMemo(() => {
        if(dataType === 'raw' || dataType === 'rawLines') {
            const preTraitCols = ['LOC','EXPT','PLOT','BLOCK','FACTOR1','FACTOR2','FACTOR3','FACTOR4','CHECKS','ROW','COLUMN'];
            const postTraitCols = ['NAME', 'PEDIGREE1', 'NAME2', 'PEDIGREE2', 'NAME3', 'PEDIGREE3', 'NAME4', 'PEDIGREE4', 'YEAR'];
            const dataCols = Object.keys(data[0]);
            const traitCols = dataCols.filter(col => !preTraitCols.includes(col) && !postTraitCols.includes(col));
            return [...preTraitCols, ...traitCols, ...postTraitCols];
        }
        else if(dataType === 'means' || dataType === 'meansLines') {
            const preTraitCols = ['FACTOR1', 'NAME', 'PEDIGREE', 'EXPT', 'LOC'];
            const postTraitCols = ['YEAR'];
            const dataCols = Object.keys(data[0]);
            const traitCols = dataCols.filter(col => !preTraitCols.includes(col) && !postTraitCols.includes(col));
            return [...preTraitCols, ...traitCols, ...postTraitCols];
        }
        else if(dataType === 'expt') {
            return ['EXPT', 'DESIGN ABBREVIATION', 'DESIGN', 'DESCRIPTION', 'YEAR', 'LOCATION', 'LOC', 'SEED', 'NAME'];
        }
    }, [data, dataType]);
    return (
        <div className="row">
            <div className="my-3 px-3 pb-3 pt-2 bg-body rounded shadow">
                <div className="row">
                    <h5>Results</h5>
                </div>
                <div className="card">
                    <OutputTable data={data} columns={columns} />
                </div>
            </div>
        </div>
    )
}

export default ResultsPanel